import React, { Component } from 'react'
import { connect } from 'react-redux'

import BkFlowNavigation from '../../components/structure/navigation/BkFlowNavigation'
import BkFlowComponents from '../../components/structure/BkFlowComponents'
import BkFlowLanguageToggle from '../../components/language/BkFlowLanguageToggle'
import BkFlowFooterBasic from '../../components/structure/footer/layouts/BkFlowFooterBasic'

import yn from 'yn'
import triggerCustomGaEvent from '../../utilities/analytics/triggerCustomGaEvent'

class BkFlowContent extends Component {

	constructor(props) {
		super(props)
		this.state = {
			editModalVisible: false
		}
	}

	toggleEditModal = () => {
		this.setState({ editModalVisible: !this.state.editModalVisible })

		const editStayDetailsData = {
			visible: !this.state.editModalVisible
		}

		triggerCustomGaEvent('analytics-editStayDetailsView', editStayDetailsData)
	}

	render() {
		return (
			<div className="bk-flow__body">
				<BkFlowNavigation
					editModalVisible={this.state.editModalVisible}
					toggleEditModal={() => this.toggleEditModal()}
				/>

				<BkFlowComponents
					toggleEditModal={() => this.toggleEditModal()}
				/>

				{ yn(process.env.REACT_APP_COMPONENT_ENABLE_LANGUAGE_TOGGLE) &&
					yn(process.env.REACT_APP_COMPONENT_LANGUAGE_UTILITY_FOOTER) &&
					<BkFlowLanguageToggle />
				}

				{ process.env.REACT_APP_COMPONENT_FOOTER === 'basic' &&
					<BkFlowFooterBasic />
				}
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration
	}
}

export default connect(mapStateToProps, null)(BkFlowContent)


// WEBPACK FOOTER //
// ./src/containers/structure/BkFlowContent.js